import { addDisplayName, addLayoutEffect, flowMax } from 'ad-hok'
import { FC } from 'react'
import { addNavigate } from 'shared/src/utils/addNavigate'

export const CatchAll: FC = flowMax(
  addDisplayName('CatchAll'),
  addNavigate,
  addLayoutEffect(
    ({ navigate }) =>
      () => {
        navigate('/')
      },
    []
  ),
  () => null
)
